import React from 'react';

import cx from 'classnames';
import { prop } from 'ramda';
import { NavLink } from 'react-router-dom';

import styles from './index.module.css';

function ItemLink(props) {
  const {
    href,
    className,
    exact = false,
    children,
    isButton = false,
    isRealLink = false,
    isSSR = false,
    onClick,
    noMargin = false,
    withDots = false,
    disabled = false,
    isDropdown = false,
    theme,
    icon,
    linkClassName,
    noUnderline = false,
    id = undefined,
    ...rest
  } = props;
  const linkClasses = cx(
    styles.link,
    withDots && prop('link-withDots', styles),
    isButton && prop('link-button', styles),
    isDropdown && prop('link-dropdown', styles),
    linkClassName,
  );
  const itemClasses = cx(
    styles.linkItem,
    noMargin && prop('linkItem-noMargin', styles),
    withDots && prop('linkItem-withDots', styles),
    disabled && prop('linkItem-disabled', styles),
    isDropdown && prop('linkItem-dropdown', styles),
    className,
  );

  const underlineClasses = !noUnderline
    ? cx(styles.underline, disabled && styles.underlineDisabled, theme && prop(`underline-${theme}`, styles))
    : undefined;

  const inner = underlineClasses ? (
    <>
      <span className={underlineClasses} />
      {children}
    </>
  ) : (
    children
  );

  if (isButton) {
    return (
      <div className={itemClasses} data-e2e-element-type="listItem" {...rest}>
        {icon && icon}
        <button disabled={disabled} type="button" className={linkClasses} onClick={onClick} children={inner} />
      </div>
    );
  }

  if (isRealLink) {
    return (
      <div className={itemClasses} data-e2e-element-type="listItem">
        {icon && icon}
        <a
          id={id}
          href={href}
          className={linkClasses}
          onClick={onClick}
          children={inner}
          target="_blank"
          rel="noopener noreferrer"
        />
        {withDots && <span className={styles.dots}>.....</span>}
      </div>
    );
  }

  if (isSSR) {
    return (
      <div className={itemClasses} data-e2e-element-type="listItem">
        {icon && icon}
        <a id={id} href={href} className={linkClasses} onClick={onClick} children={inner} />
        {withDots && <span className={styles.dots}>.....</span>}
      </div>
    );
  }

  return (
    <div className={itemClasses} data-e2e-element-type="listItem">
      {icon && icon}
      <NavLink
        to={href}
        className={linkClasses}
        activeClassName={cx(styles.linkActive, disabled && styles.linkActiveDisabled, 'active')}
        exact={exact}
        children={inner}
        id={id}
      />
      {withDots && <span className={styles.dots}>.....</span>}
    </div>
  );
}

export default ItemLink;
